import { IConfiguration } from "../typings";

/*
    chatServer: 'https://26cddebc.ngrok.io/v1/chatbot/fbm/8a0a5a37-c2db-4006-9e56-1e8b6ab0e13f/webhook-logic',
    chatServerNotificator :'http://192.168.1.180:8082/DAVOS',
    iconTitle: 'https://www.davos.ch/chatbot-slack/assets/images/bea_icon_mini.png',
    bubbleAvatarUrl: 'https://www.davos.ch/chatbot-slack/assets/images/bea_icon_mini.png',
    title: 'Hi, ich bin Bea',
    subTitle: 'Deine digitale Assistentin in Davos Klosters',
    placeholderText: 'Chatte mit mir…',
    introMessage: '',
    mainColor: '#3FA2D5',
    headerTextColor: '#ffffff',
    bubbleBackground: '#3FA2D5',
    buttonColor: '#3FA2D5',
*/

export const defaultConfiguration: IConfiguration = {
    aboutLink: 'https://www.jovin.ai/',
    aboutText: 'Powered by Jovin',
    alwaysUseFloatingButton: false,
    bubbleMessage: '',
    chatId: '',
    chatServer: '',
    chatServerNotificator: '',
    cookieValidInDays: 1,
    dateTimeFormat: 'm/d/yy HH:MM',
    desktopHeight: 450,
    desktopWidth: 370,
    displayMessageTime: false,
    echoChannel: (userId) => 'humanSwitch.' + userId,
    echoChannelType: 'private',
    echoConfiguration: {},
    echoEventName: 'HumanSwitch.SupportMessageReceived',
    endpoint: '',
    frameEndpoint: '/jovin-widget/chat.php',
    introMessage: '',
    locale: 'de',
    mobileHeight: 'calc(100% - 102px)',
    mobileWidth: '300px',
    name: '',
    placeholderText: '',
    sendWidgetOpenedEvent: false,
    showBubble: false,
    showLocaleToggler: false,
    showChatbotReview: false,
    subTitle: '',
    test: 0,
    themeSettings: {
        mainColor: '#3FA2D5',
        headerTextColor: '#ffffff',
        bubbleBackground: 'transparent',
        buttonColor: 'transparent',
        bubbleAvatarUrl: 'https://backend.jovin.ai/jovin-widget/assets/defaultAvatar.png',
        iconTitle: 'https://backend.jovin.ai/jovin-widget/assets/defaultAvatar.png',
        sendButtonIcon: '/jovin-widget/assets/button_send.svg',
        lightMode: false
    },
    timeFormat: 'HH:MM',
    title: '',
    useEcho: false,
    userId: '',
    uuid: '',
    videoHeight: 160,
    widgetOpenedEventData: ''
};
